import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Modal from "../../../Modal";
import Form, { Title, Submit, Cancel, InputTextArea } from "../../../Form";

import messages from "./messages";
import { IProps } from "./interfaces";

const ChangeDescriptionModal = (props: IProps) => {
    const { close, modifyHomeworkDescription } = props;
    const { formatMessage } = useIntl();
    const [description, setDescription] = useState(props.description);
    const [loading, setLoading] = useState(false);
    const handleChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
        setDescription(e.currentTarget.value)
    };
    const handleModify = () => {
        setLoading(true);
        modifyHomeworkDescription(description, close, () => {
            setLoading(false);
        });
    };

    return (
        <Modal close={close}>
            <Title>
                <FormattedMessage
                    {...messages.modifySomething}
                    values={{ value: formatMessage(messages.homeworkDescription) }}
                />
            </Title>
            <Form disabled={loading}>
                <InputTextArea
                    value={description}
                    maxLength={500}
                    onChange={handleChange}
                    label={<FormattedMessage {...messages.homeworkDescription} />}
                    selectAllOnMount
                />
                <Submit onClick={handleModify} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeDescriptionModal;
